import React from "react";
import { Text } from "../../../core/design-system/Text";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useTheme } from "../../../../theme/ThemeProvider";
import { getCurrentCurrency } from "../../../../utils/currencyFormatter";
interface GraphViewProps {
  // Define your prop types here
}

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  aspectRatio: 4,
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },

    title: {
      display: false,
    },
  },

  scales: {
    x: {
      display: true,
      title: {
        display: false,
        text: "Custom X Axis Label",
      },
      grid: { display: false },
      ticks: {
        beginAtZero: true,
        stepSize: 10,
        font: {
          size: 14,
        },
      },
    },
    y: {
      grid: { display: false },
      display: true,

      ticks: {
        callback: function (value: any, index: any, values: any) {
          if (value >= 1000) {
            return value / 1000 + "K";
          }
          return value;
        },
        beginAtZero: true,
        stepSize: 10000,
        font: {
          size: 14,
        },
      },
    },
  },
  categoryPercentage: 0.5,
};

const getThemeColors = (theme: string) => {
  return {
    firstItem: theme === "digibank" ? "#90BE6D" : "#D3940F",
    secondItem: theme === "digibank" ? "#F3722C" : "#06486C",
  };
};

const data = (theme: string) => ({
  labels: ["3 Jul", "7 Jul", "15 Jul", "19 Jul", "23 Jul", "27 Jul", "31 Jul"],
  datasets: [
    {
      label: "My First dataset",
      backgroundColor: getThemeColors(theme).firstItem,
      borderColor: getThemeColors(theme).firstItem,
      borderWidth: 1,
      borderRadius: 4,
      data: [3500, 39000, 30000, 31000, 46000, 45000, 40000],
      barThickness: 15,
      barPercentage: 0.5,
    },
    {
      label: "My second dataset",
      backgroundColor: getThemeColors(theme).secondItem,
      borderColor: getThemeColors(theme).secondItem,
      borderWidth: 1,
      borderRadius: 4,
      data: [45000, 49000, 50000, 41000, 16000, 35000, 20000],
      barThickness: 15,
      barPercentage: 0.5,
    },
  ],
});

const GraphView: React.FC<GraphViewProps> = (props) => {
  const { theme } = useTheme();
  return (
    <div className="border border-gray-300_01 rounded-lg py-[32px] px-[24px]">
      <div className="flex flex-row gap-5">
        <div className="flex flex-col">
          <Text
            size="md"
            className=" text-gray-50_04 text-xl xs:font-medium 5xl:font-normal"
          >
            28453.56
            <sup className="text-[12px]">{""}{getCurrentCurrency().code}</sup>
          </Text>
          <Text size="s" className="flex  text-[12px] text-left items-center">
            <span className=" text-accHeader text-[30px]">•</span>{" "}
            <span className="opacity-50">Received</span>
          </Text>
        </div>
        <div className="flex flex-col">
          <Text size="md" className=" text-gray-50_04 text-xl">
            28453.56
            <sup className="text-[12px]">{""}{getCurrentCurrency().code}</sup>
          </Text>
          <Text size="s" className="flex  text-[12px] text-left items-center">
            <span className=" text-red-400 text-[30px]">•</span>{" "}
            <span className="opacity-50">Paid</span>
          </Text>
        </div>
      </div>

      <Bar data={data(theme)} options={options} />
    </div>
  );
};

export default GraphView;
